import SelectFromQuery, { SelectFromQueryProps } from '../SelectFromQuery';

import { GetAirportGroupsDocument } from '@/api/queries';

const SelectAirportGroup = ({ ...props }: Partial<SelectFromQueryProps>) => (
  <SelectFromQuery
    cache="AirportGroups"
    placeholder="All Airports"
    query={GetAirportGroupsDocument}
    selector={(data) =>
      (data?.getFilters?.filters?.airportGroups || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
        values: opt.values,
      }))
    }
    sticky
    {...props}
    options={{
      showSelectAll: false,
      ...(props.options || {}),
    }}
  />
);

export default SelectAirportGroup;
